import React, { useEffect, useState } from "react";
import ManageUsers from "./ManageUsers";
import OrdersList from "../OrdersList";
import AdminDashboard from "../../../Admin/Settings/AdminCard"; // Imported as AdminDashboard but file is AdminCard

const AdminDashboardHome = () => {
  const [totalOrders, setTotalOrders] = useState(0);
  const [totalUsers, setTotalUsers] = useState(0);

  useEffect(() => {
    fetch("https://allinone-clone-7d5d795e98ce.herokuapp.com/orders")
      .then((res) => res.json())
      .then((data) => setTotalOrders(data.length || 0));
    fetch("https://allinone-clone-7d5d795e98ce.herokuapp.com/users")
      .then((res) => res.json())
      .then((data) => setTotalUsers(data.length || 0));
  }, []);

  return (
    <div className="admin-dashboard-home">
      <AdminDashboard
        totalOrders={totalOrders || 0}
        totalUsers={totalUsers || 0}
      />
      <OrdersList />
      {/* <ManageUsers /> */}
    </div>
  );
};

export default AdminDashboardHome;
